import { useInjection } from '../di';
import { TOAST_TOKEN } from './di';

export const useToastManager = () => useInjection(TOAST_TOKEN);
